<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title> Last Minute job </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="name && jobId && user_id">
  <mable-heading heading="h2">Confirm booking with {{ name }}</mable-heading>
  <p class="body-semi-bold ion-margin-horizontal">Notify {{ name }} that you have accepted their offer?</p>
  <p class="body-normal-16 ion-margin-horizontal">
    Other workers who have made offers will be notified that the job is filled.
  </p>
</ion-content>
<ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col size="6">
        <mable-button
          expand="block"
          category="outline"
          (onClick)="modalCtrl.dismiss()"
          >Cancel</mable-button
        >
      </ion-col>
      <ion-col size="6">
        <mable-button
          expand="block"
          (onClick)="confirmBooking()"
          >Confirm</mable-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
